import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Store, ShieldCheck, Clock } from "lucide-react";
import ProstoHeader from "@/prosto/ProstoHeader";
import ProstoInstallGuide from "@/prosto/ProstoInstallGuide";

export default function ProstoGuide() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#f5f6f8] pb-8 text-slate-900 shadow-[0_0_0_100vmax_#f5f6f8]" data-testid="prosto-guide-page">
      <ProstoHeader title="Как установить" back />

      <div className="px-3 pt-5">
        {/* Hero */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          className="relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-5 shadow-sm"
        >
          <div className="relative z-10 max-w-full">
            <h1 className="font-display text-2xl font-extrabold text-slate-900 leading-tight">
              Как установить приложение
            </h1>
            <p className="mt-2 text-[13px] text-slate-600 leading-relaxed">
              Следуйте шагам на экране. При выходе выберите «Выйти, но не стирать данные».
            </p>
          </div>
        </motion.div>

        {/* Reassurance */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.05 }}
          data-testid="prosto-guide-safe-banner"
          className="mt-4 flex items-start gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm"
        >
          <span className="shrink-0 grid place-items-center w-9 h-9 rounded-xl bg-blue-50 text-[#2F6BFF]">
            <ShieldCheck size={20} />
          </span>
          <div className="text-[13px] leading-relaxed text-slate-600">
            <b className="font-bold">Проверьте вариант выхода.</b> Выберите «Выйти, но не стирать данные», затем нажмите «Продолжить». Не выбирайте стирание данных.
          </div>
        </motion.div>

        {/* Timing hint */}
        <div className="mt-3 flex items-center gap-2 text-xs text-slate-500 px-1">
          <Clock size={14} className="text-[#2F6BFF]" />
          Занимает около 2 минут
        </div>

        {/* Steps */}
        <section className="mt-5">
          <ProstoInstallGuide />
        </section>

        {/* CTA */}
        <motion.button
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          data-testid="prosto-guide-choose-app-button"
          onClick={() => navigate("/prosto/search")}
          className="mt-6 w-full flex items-center justify-center gap-2 py-3.5 rounded-2xl font-bold text-white bg-[#2F6BFF] active:scale-95 transition shadow-sm shadow-blue-500/25"
        >
          <Store size={18} /> Выбрать приложение
        </motion.button>
      </div>
    </div>
  );
}
